@if (isLoading()) {
  <div class="loading-container">
    <p-progressSpinner></p-progressSpinner>
    <p>Loading patients...</p>
  </div>
} @else {
<div class="patients-container">
  <!-- Header Section (desktop title only; Add Patient is beside Filter in the directory card) -->
  <div class="header-section">
    <h1>Patients</h1>
  </div>

  <!-- Patient Directory Section -->
  <p-card class="patient-directory-section">
    <!-- Header inside card body -->
    <div class="card-header-custom">
      <h3>Patient Directory</h3>
    </div>
    
    <!-- Search and Filter -->
    <div class="search-filter-container row">
      <div class="search-container col-lg-8 col-md-8 col-sm-8">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input 
            pInputText
            placeholder="Search patients..." 
            [value]="searchText"
            (input)="onSearchInput($event)"
            class="search-input">
        </span>
      </div>
      <div class="filter-container col-lg-4 col-md-4 col-sm-4">
        <div class="directory-actions-row">
          <p-button
            label="Filter"
            icon="pi pi-filter"
            (onClick)="onFilterClick()"
            class="filter-button">
          </p-button>
          <p-button
            label="Add Patient"
            icon="pi pi-plus"
            class="add-patient-btn"
            (onClick)="showAddPatientModal()">
          </p-button>
        </div>
      </div>
    </div>

    <!-- Patients Table -->
    <div class="table-container">
      <p-table 
        [value]="filteredPatients()" 
        [paginator]="true" 
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        [showJumpToPageDropdown]="false"
        class="patients-table"
        styleClass="patients-directory-datatable">
        
        <ng-template pTemplate="header">
          <tr>
            <th>MRN</th>
            <th>Name</th>
            <th>DOB</th>
            <th>Last Visit</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="body" let-patient>
          <tr>
            <td>{{ patient.mrn }}</td>
            <td>
              <a [routerLink]="['/v0/patients', patient.mrn]" class="patient-name-link">
                {{ patient.firstName }} {{ patient.lastName }}
              </a>
            </td>
            <td>{{ formatDateMdYyyy(patient.dateOfBirth) }}</td>
            <td>{{ getLastVisitDate(patient) }}</td>
            <td>
              <span class="patient-status" [ngClass]="{'status-active': patient.active, 'status-inactive': !patient.active}">
                {{ patient.active ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>
              <div class="action-buttons">
                <p-button 
                  label="View"
                  [routerLink]="['/v0/patients', patient.mrn]"
                  class="view-button"
                  size="small"
                  severity="secondary"
                  [outlined]="true">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-card>

  <!-- Patient Statistics + Recent Patients (stacked full width — matches transcriptions-style vertical rhythm) -->
  <div class="patients-secondary-stack">
    <div class="patients-stack-block">
      <p-card class="patient-statistics-section">
        <!-- Header inside card body -->
        <div class="card-header-custom">
          <h2 class="patients-card-list-heading">Patient Statistics</h2>
        </div>
        <div class="statistics-list">
          <div class="statistic-item">
            <div class="stat-row">
              <h4 class="stat-label">Total Patients</h4>
              <span class="stat-value">{{ totalPatients() }}</span>
            </div>
          </div>
          <div class="statistic-item">
            <div class="stat-row">
              <h4 class="stat-label">New This Month</h4>
              <span class="stat-value">{{ newThisMonth() }}</span>
            </div>
          </div>
          <div class="statistic-item">
            <div class="stat-row">
              <h4 class="stat-label">Appointments This Week</h4>
              <span class="stat-value">{{ appointmentsThisWeek() }}</span>
            </div>
          </div>
          <div class="statistic-item">
            <div class="stat-row">
              <h4 class="stat-label">Average Visits Per Patient</h4>
              <span class="stat-value">{{ averageVisitsPerPatient() }}</span>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <div class="patients-stack-block">
      <p-card class="recent-patients-section">
        <!-- Header inside card body -->
        <div class="card-header-custom">
          <h2 class="patients-card-list-heading">Recent Patients</h2>
        </div>
        <div class="recent-patients-list">
          @if (recentPatients().length > 0) {
            @for (patient of recentPatients(); track patient.mrn) {
            <div class="recent-patient-row">
              <div class="patient-info">
                <h4>{{ patient.firstName }} {{ patient.lastName }}</h4>
                <p class="condition">Active</p>
              </div>
              <div class="action-buttons">
                <p-button 
                  label="View"
                  [routerLink]="['/v0/patients', patient.mrn]"
                  class="view-button"
                  size="small"
                  severity="secondary"
                  [outlined]="true">
                </p-button>
              </div>
            </div>
            }
          } @else {
            <div class="empty-state">
              <p class="empty-state-text">No recent patients</p>
            </div>
          }
        </div>
      </p-card>
    </div>
  </div>

  <!-- Patient Modal -->
  <app-patient-modal
    [mode]="modalMode"
    [(visible)]="displayPatientModal"
    [patient]="selectedPatient"
    (patientSaved)="onPatientSaved($event)"
    (visibleChange)="onModalClosed()">
  </app-patient-modal>
</div> 
}